import gql from "graphql-tag"
import { ResponsiveImageFields } from "../../../../dato/DatoContent/fragments"

/**
 * Global PDM Asset row-configuration records from Dato.
 * Fetches ALL pdmAsset records (Front Row, Back Row, Middle Row).
 * Each pdmAsset.title corresponds to a PDM part_attributes[].attribute value.
 * Row option images in PDM V2 are sourced only from this query.
 */
export const pdmAssetRowsQuery = gql`
  ${ResponsiveImageFields}
  query pdmAssetRows {
    allPdmAssets(fallbackLocales: en, locale: en) {
      id
      title
      value
      key
      options
      rows {
        id
        title
        value
        key
        image {
          responsiveImage {
            ...ResponsiveImageFields
          }
        }
      }
    }
  }
`
